import { makeHttpClient, _unwrapAxiosResponse } from "./http";

import env from "../environment/env.json";

export class CAMSupportOverViewDataService {
  private httpClient = makeHttpClient();
  //please config env as well
  getCAMListData(query: any) {
    let url = env.CAMSuppoprtOverviewUrl;
    if (query) {
      url = url + "/?" + query;
    }
    return _unwrapAxiosResponse(
      this.httpClient.get<CAMSupportOverViewDataService>(url)
    );
  }

  get(id: string) {
    // return _unwrapAxiosResponse(
    //   this.httpClient.get(`${env.countryStreamAssignmentUrl}${id}/`)
    // );
  }

  update(form: any) {
    const data = {
      country_id: form.country_id,
      stream_id: form.stream_id,
      customer_account_manager_id: form.account_manager_id,
      customer_selection_type: form.customer_selection_type,
      excluded_customer_id: form.excluded_customer_id,
      included_customer_id: form.included_customer_id
    };
    return _unwrapAxiosResponse(
      this.httpClient.put<CAMSupportOverViewDataService>(
        // `${env.CAMSuppoprtOverviewUrl}${id}/`
        env.CAMSuppoprtOverviewUrl + "/" + form.id,
        data
      )
    );
  }

  delete(data: any) {
    return _unwrapAxiosResponse(
      this.httpClient.delete<CAMSupportOverViewDataService>(
        env.CAMSuppoprtOverviewUrl + "/" + data.id
      )
    );
    // return _unwrapAxiosResponse(
    //   this.httpClient.post(`${env.countryStreamAssignmentUrl}`, data)
    // );
  }

  create(form: any) {
    const data = {
      country_id: form.country_id,
      stream_id: form.stream_id,
      customer_account_manager_id: form.account_manager_id,
      customer_selection_type: form.customer_selection_type,
      excluded_customer_id: form.excluded_customer_id,
      included_customer_id: form.included_customer_id
    };
    return _unwrapAxiosResponse(
      this.httpClient.post<CAMSupportOverViewDataService>(
        env.CAMSuppoprtOverviewUrl,
        data
      )
    );
  }
}

export default CAMSupportOverViewDataService;
